export default __webpack_public_path__ + "static/media/feature3.2c5ccd43.png";